module.exports = __webpack_public_path__ + "img/silhouette-female.db7d313f.png";